import * as React from 'react';
import {SwitchBtn} from "../../SwitchBtn";
import {useState} from "react";
import {finesseDetailInterface} from "./iUpload";

interface SwitchActionConformityProps {
  data: {
    etatConformity: string | null,
    logsConformity: string | null,
    fileRegisteredId: string | null
  };
  canDeclareDestructure: boolean | false,
  isInternalUserAdmin: boolean | false,
  finesseDetails: finesseDetailInterface,
  handleChangeConformity: any,
  disabled: boolean,
  isBroderie?: boolean
}

export const SwitchActionConformity = (props: SwitchActionConformityProps) => {
  const [etat, setEtat] = useState<boolean>(props.data.etatConformity != null);
  const logs = props.data.logsConformity;
  const fileRegisteredId = props.data.fileRegisteredId;
  const strTitle = `Fichier destructuré ${logs && etat ? `(${logs})` : ''}`;
  const isBroderie = props.isBroderie;

  function changeConformity(event: boolean) {
    const phrase1 = 'Ce fichier ne peut être considéré comme étant "destructuré" par le système.';
    if(!props.disabled && event && !props.canDeclareDestructure && props.finesseDetails && props.finesseDetails.nbrElementsIsoles && props.finesseDetails.nbrElementsIsoles >= 0) {
      if(!props.isInternalUserAdmin) {
        alert(`${phrase1} Veuillez prévenir un responsable si ce comportement vous semble anormal.`);
      } else {
        const detailFinesse = ` Le nombre d'éléments isolés est insuffisant : ${props.finesseDetails.nbrElementsIsoles}. `;
        if(confirm(`${phrase1} ${detailFinesse} Souhaitez-vous poursuivre malgré tout ? \nVous prenez la responsabilité de l'impact de votre action sur le système.`)) {
          setEtat(event);
          props.handleChangeConformity(event);
        }
      }
    } else {
      const alert = "Êtes-vous sûr de vouloir signaler ce fichier comme étant \"destructuré\" ? Certains éléments ne tiendront pas sur le textile.\nVous prenez la responsabilité de l'impact de votre action sur le système.";
      if (!props.disabled && ((event && confirm(alert)) || !event)) {
        setEtat(event);
        props.handleChangeConformity(event);
      }
    }
  }

  const labelStyle = (props.disabled || isBroderie) ? {cursor: 'not-allowed'} : {};

  let title = isBroderie ? 'Cette action n\'est pas autorisée pour de la broderie. Adaptez votre fichier.' : '';
  title = props.disabled && !isBroderie ? 'Action non autorisée' : title;

  return (
    <div className={`d-flex`} title={title}>
      <SwitchBtn isDestructureBtn={true} value={etat} customClasses={`${props.disabled ? 'opac30' : ''}`} labelStyle={labelStyle} disabled={isBroderie || props.disabled} onChangeEvent={(e) => { changeConformity(e) }}/>
      <div className={"ml-4 w100 align-self-center"}>{strTitle} - <span className={'bold'}>Identifiant</span> : {fileRegisteredId}</div>
    </div>
  );
}